import Vue from 'vue'
// import axios from 'axios'
import axios from '@/wrappers/axios.js'
// import store from '../../store';

const DiagramService = {

    diagramList(params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/diagrams${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    createDiagram(data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/diagrams`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    getDiagram(id, params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/diagrams/${id}${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    updateDiagram(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .put(`/diagrams/${id}`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
}

Vue.$diagramService = DiagramService

export default DiagramService